(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tempus-mobile-buy"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const btn=event.target.closest('[data-tempus-to-options]');
  if(!btn)return;
  const target=document.querySelector('variant-picker,variant-selects,.variant-picker,form[action*="/cart/add"],product-form');
  if(target){target.scrollIntoView({behavior:'smooth',block:'center'});}else{window.scrollTo({top:0,behavior:'smooth'});}
});

  } catch(e) { console.error(e); }
})();
})();
